import { observer } from "mobx-react-lite";
import React, { useLayoutEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export const LineChart = observer(({ data, label, value, chartId = "line_chart" }: any) => {
    const chartRef = useRef<am4charts.XYChart | null>(null);

    useLayoutEffect(() => {
        const chart = am4core.create(chartId, am4charts.XYChart);
        chart.data = data;
        chart.dateFormatter.inputDateFormat = "yyyy-MM-dd";

        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        chart.yAxes.push(new am4charts.ValueAxis());

        const series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = value;
        series.dataFields.dateX = label;
        series.tooltipText = "{value}";
        series.strokeWidth = 2;
        series.fillOpacity = 0.3;
        series.fill = am4core.color("#8B5CF6");
        series.stroke = am4core.color("#8B5CF6");

        series.tooltip.background.cornerRadius = 20;
        series.tooltip.background.strokeOpacity = 0;
        series.tooltip.pointerOrientation = "vertical";

        const bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.strokeWidth = 2;
        bullet.circle.radius = 3;
        bullet.circle.fill = am4core.color("#FFF");

        chart.cursor = new am4charts.XYCursor();
        chartRef.current = chart;

        return () => {
            chart.dispose();
        };
    }, [data, label, value, chartId]);

    return <div id={chartId} className="flex h-96 w-full flex-col" />;
});
